import { File as NativeFile } from '@ionic-native/file';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { _throw } from 'rxjs/observable/throw';
import { VASRestService } from '../../../core/services/api/vas-rest';
import { FileChangeQItem } from '../../../core/services/sync-up/file-item';
import { FileSystemHelper } from '../../helpers/file-system.helper';
import { CordovaFileHelper } from '../../helpers/file-system/cordova-file.helper';
import { FileHelper, PathInfoType } from '../../helpers/file-system/file.helper';
import { FileUploadHelperInterface } from './file-upload-helper.interface';
import { FileUploaderBaseHelper } from './file-uploader-base.helper';

export class FileUploaderCordovaHelper extends FileUploaderBaseHelper implements FileUploadHelperInterface {

    constructor(
        protected file: FileChangeQItem,
        protected api: VASRestService,
        protected nativeFileService: NativeFile
    ) {
        super(file, api);
    }

    protected getBlob(path: string): Observable<Blob> {

        const parts = FileHelper.parsePath(path);

        switch (parts.type) {
            // this handles the case when the user adds a file from the library
            // using native File Manager
            case PathInfoType.BLOB: {
                return fromPromise(FileSystemHelper.objectUrlToBlob2(path));
            }
            // this handles the case when the user adds a file from the camera
            case PathInfoType.FILESYSTEM: {
                return fromPromise(CordovaFileHelper.pathToBlob(
                    path,
                    this.nativeFileService
                ));
            }
            default: {
                return _throw(
                    Error(`Path is not of type BLOB or FILESYSTEM ${path}`)
                );
            }
        }
    }

    prepare(path: string): Promise<any> {
        return Promise.resolve();
    }

    readChunk(path: string, index: number, size: number): Observable<Blob> {

        const parts = FileHelper.parsePath(path);

        switch (parts.type) {
            case PathInfoType.BLOB: {
                return fromPromise(FileSystemHelper.objectUrlToBlob2(path))
                    .map(blob => {
                        const from = Math.min(index * size, blob.size);
                        const to = Math.min(
                            (index + 1) * size,
                            blob.size
                        );
                        return blob.slice(from, to, blob.type);
                    });
            }
            case PathInfoType.FILESYSTEM: {
                return fromPromise(CordovaFileHelper.pathToCordovaFile(
                    path,
                    this.nativeFileService
                )).concatMap(cordovaFile =>
                    CordovaFileHelper.readChunk(cordovaFile, index, size)
                );
            }
            default: {
                return _throw(
                    Error(`Path is not of type BLOB or FILESYSTEM ${path}`)
                );
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/lib/file-uploader/file-uploader-cordova.helper.ts